export default __webpack_public_path__ + "assets/elichens-logo.3e9650a4.svg";